
<label
  class="form-check-label mr-4"
  *ngFor="let option of options; let optindex = index"
>
  <input
    type="radio"
    [(ngModel)]="selectValue"
    class="form-check-input"
    [name]="name"
    [value]="option.value"
    (ngModelChange)="
      changeAffinityQuestionOption(Universityindex, Affinityindex, option)
    "
  />
  <span *ngIf="option.value">{{ firstLetterUpper(option.value) }}</span>
  <!-- <span *ngIf="(option.value) &&  (option.value!='yes' || option.value!='no')">{{ option.value }}</span> -->
  <!-- <span *ngIf="option.value=='yes.' || option.value=='yes'">Yes</span>
      <span *ngIf="option.value=='no'">No</span> -->
</label>
<!-- (change)="changeAffinityQuestionOption(Universityindex,Affinityindex,option.amount,option.value) -->
